// Function to get browser language
const getBrowserLanguage = (): string | null => {
  if (typeof window === 'undefined') return null;

  try {
    // Try multiple browser language properties
    const browserLang = 
      navigator.language || 
      (navigator as any).userLanguage || 
      (navigator.languages && navigator.languages[0]);

    if (browserLang) {
      return browserLang;
    }

    return null;
  } catch (error) {
    console.error('❌ Error detecting browser language:', error);
    return null;
  }
};

export default getBrowserLanguage;
